import React from 'react';
import { GetStaticProps } from 'next';
import { useTranslations } from 'next-intl';

import { Main, TopicTestSection } from 'modules/auto-test';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();

  return (
    <>
      <NextHead title={t('meta.auto_test_landing.title')} description={t('meta.auto_test_landing.description')} />
      <div className="mx-auto my-7 min-h-screen max-w-screen p-4">
        <Main />
        <TopicTestSection />
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
      messages: (await import(`../../messages/${locale}.json`)).default
    }
  });
